import { createEtDom, mountedToDom } from "utils";
import { getIsMobile } from "utils/device";

const etParams = {
  extra_definitions: [
    {
      type: 13,
      selector: "[data-title]",
      attribute: "data-title",
    },
    {
      type: 14,
      selector: "[data-description]",
      attribute: "data-description",
    },
  ],
};

/**
 * 挂载到header
 */
const mountedToHeader = (): void => {
  mountedToDom(["HeaderMenuBefore"], () => {
    return createEtDom('div', false, etParams)
  });
};

/**
 * 挂载到抽屉
 */
const mountedToDrawer = (): void => {
  mountedToDom(["HeaderDrawerInfoBottom"], () => {
    return createEtDom('div', true, etParams)
  });
};

const translateAthena = function () {
  const mobileWidth = 767; // 移动端屏幕宽度临界值
  const isMobile = getIsMobile(mobileWidth);

  const isOrderPage = new RegExp(/\/order?-\w+|orders\/\d+/).test(
    location.pathname
  );

  if (isOrderPage) {
    createEtDom('div', isMobile, etParams)

    return;
  }

  if (!isMobile) {
    mountedToHeader();
  } else {
    mountedToDrawer();
  }
};

export { translateAthena };
